import { render, staticRenderFns } from "./WY-PH-Notice.vue?vue&type=template&id=e14c011c&scoped=true&"
import script from "./WY-PH-Notice.vue?vue&type=script&lang=js&"
export * from "./WY-PH-Notice.vue?vue&type=script&lang=js&"
import style0 from "./WY-PH-Notice.vue?vue&type=style&index=0&id=e14c011c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e14c011c",
  null
  
)

export default component.exports